export const unities = [
    'pieces',
    'm2',
    'ml',
    'kg',
    'l'
];








// WEBPACK FOOTER //
// ./src/app/interfaces/unit.ts